import { AuthTypeEnum } from "./login.component";

export class LoginInputModel {
  public Username: string;
  public Password: string;
  public RememberLogin;
  public ReturnUrl: string
  public Language: string
  public BusinessUnit: string
  public BusinessUnitName: string
  public BusinessUnitAName: string
  public UserCode: string
  public Token: string
  public FWToken: string
  public ODataToken: string
  public refreshToken: string
  public BOToken: string
  public Client: string
  public AuthType: AuthTypeEnum;
}
